import {
  FileTextOutlined,
  LinkOutlined,
  VideoCameraOutlined,
  CheckCircleFilled,
  PlayCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  ObjectiveType,
  ObjectiveCompletionStatus,
} from "../../../types/client-education-detail.types";
import type { ObjectiveDto } from "../../../types/client-education-detail.types";
import styles from "./ContentSection.module.scss";

function typeIcon(t: ObjectiveType) {
  if (t === ObjectiveType.LINK) return <LinkOutlined />;
  if (t === ObjectiveType.JITSI) return <VideoCameraOutlined />;
  return <FileTextOutlined />;
}

function statusEl(s?: ObjectiveCompletionStatus) {
  if (s === ObjectiveCompletionStatus.COMPLETED)
    return <span className={styles.done}><CheckCircleFilled /></span>;
  if (s === ObjectiveCompletionStatus.IN_PROGRESS)
    return <span className={styles.inProg}><LoadingOutlined /></span>;
  return <span className={styles.notStarted}><PlayCircleOutlined /></span>;
}

export function ObjectiveRow(props: {
  objective: ObjectiveDto;
  active: boolean;
  onSelect: () => void;
}) {
  const { objective, active, onSelect } = props;
  const durationMin =
    objective.durationMinutes ?? objective.file?.durationMinutes ?? null;
  return (
    <button
      type="button"
      onClick={onSelect}
      className={`${styles.objRow} ${active ? styles.objRowActive : ""}`}
    >
      <span className={styles.objIcon}>{typeIcon(objective.type)}</span>
      <span className={styles.objTitle}>{objective.title}</span>
      {durationMin != null && (
        <span className={styles.objDuration}>{durationMin} dk</span>
      )}
      <span className={styles.objStatus}>{statusEl(objective.completionStatus ?? objective.status)}</span>
    </button>
  );
}
